<template>
  <b-modal
    id="cropper-modal"
    :modal-class="'default-modal'"
    :hide-footer="true"
    @shown="shown"
    @hidden="reset"
  >
    <template v-slot:modal-title>
      Redimensione a mídia
    </template>

    <template v-slot:default>
      <div class="text-center font-size-xSmall">
        <p>Aumente, diminua ou reposicione a imagem</p>
      </div>
      <div>
        <Croppa
          v-model="cropper"
          :initial-image="localSrc"
          :disable-click-to-choose="true"
          :show-remove-button="false"
          :prevent-white-space="true"
          :width="width"
          :height="height"
          @zoom="onZoom"
        />
      </div>
      <div class="range-wrap default-form d-flex justify-content-center align-items-center mt-3">
        <div>
          <i class="fa fa-search-minus text-color2" />
        </div>
        <div class="text-center custom-range-input">
          <input
            type="range"
            @input="onSliderChange"
            :min="sliderMin"
            :max="sliderMax"
            step=".001"
            v-model="sliderVal"
          />
        </div>
        <div>
          <i class="fa fa-search-plus text-color2" />
        </div>
      </div>
      <div class="text-center mt-3">
          <Button
            class="btn btn-sm btn-outline-color2"
            @click="crop"
          >Salvar imagem</Button>
        </div>
    </template>
  </b-modal>
</template>

<script>

import 'vue-croppa/dist/vue-croppa.css'

import Button from '@/components/common/Button/Button'
import Croppa from 'vue-croppa'

export default {
  name: 'CropperModal',
  props: ['src'],
  components: {
    Button,
    Croppa: Croppa.component
  },
  data () {
    return {
      localSrc: '',
      cropper: {},
      width: 200,
      height: 200,
      sliderVal: 0,
      sliderMin: 0,
      sliderMax: 0,
      event: null
    }
  },
  mounted () {
    this.calculateSizes()
  },
  beforeDestroy () {},
  watch: {
    src (newVal) {
      this.localSrc = newVal
    },
    localSrc (newVal) {
      if (newVal) this.$bvModal.show('cropper-modal')
    }
  },
  methods: {
    calculateSizes () {
      const width = window.innerWidth
      if (width > 576) {
        this.width = 411
        this.height = 128
      } else {
        this.width = 277
        this.height = 87
      }
    },
    onSliderChange (evt) {
      var increment = evt.target.value
      this.cropper.scaleRatio = +increment
    },
    onZoom () {
      // To prevent zooming out of range when using scrolling to zoom
      if (this.sliderMax && this.cropper.scaleRatio >= this.sliderMax) {
        this.cropper.scaleRatio = this.sliderMax
      } else if (this.sliderMin && this.cropper.scaleRatio <= this.sliderMin) {
        this.cropper.scaleRatio = this.sliderMin
      }

      this.sliderVal = this.cropper.scaleRatio
    },
    crop () {
      this.cropper.generateBlob(blob => {
        this.$emit('cropped', blob)
        this.$bvModal.hide('cropper-modal')
      }, 'image/jpeg', 1)
    },
    shown () {
      // Watch for window resize
      const event = e => {
        this.calculateSizes()
      }
      window.addEventListener('resize', event)
      this.event = event
      this.cropper.refresh()
      this.sliderVal = this.cropper.scaleRatio
      this.sliderMin = this.cropper.scaleRatio / 2
      this.sliderMax = this.cropper.scaleRatio * 2
    },
    reset () {
      this.localSrc = ''
      window.removeEventListener('resize', this.event)
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .croppa-container {
    border: 3px solid $color2;
    margin: 0 auto;
  }
}

.range-wrap {
  margin: 0 auto;
  max-width: 300px;
}

.default-form .custom-range-input {
  height: 24px;
  margin: 0 10px;

  input[type=range] {
    -webkit-appearance: none; /* Hides the slider so that custom slider can be made */
    width: 100%; /* Specific width is required for Firefox. */
    background: transparent; /* Otherwise white in Chrome */
  }

  input[type=range]::-webkit-slider-thumb {
    -webkit-appearance: none;
  }

  input[type=range]:focus {
    outline: none; /* Removes the blue border. You should probably do some kind of focus styling for accessibility reasons though. */
  }

  input[type=range]::-ms-track {
    width: 100%;
    cursor: pointer;

    /* Hides the slider so custom styles can be added */
    background: transparent;
    border-color: transparent;
    color: transparent;
  }

  /* Special styling for WebKit/Blink */
  input[type=range]::-webkit-slider-thumb {
    -webkit-appearance: none;
    margin-top: -14px; /* You need to specify a margin in Chrome, but in Firefox and IE it is automatic */
    -webkit-box-shadow: 0 0 4px 0 rgba(0,0,0,0.3);
    box-shadow: 0 0 4px 0 rgba(0,0,0,0.3);
    border: none;
    height: 15px;
    width: 15px;
    border-radius: 30px;
    background: #ffffff;
    cursor: pointer;
  }

  /* All the same stuff for Firefox */
  input[type=range]::-moz-range-thumb {
    -webkit-box-shadow: 0 0 4px 0 rgba(0,0,0,0.3);
    box-shadow: 0 0 4px 0 rgba(0,0,0,0.3);
    border: none;
    height: 15px;
    width: 15px;
    border-radius: 30px;
    background: #ffffff;
    cursor: pointer;
  }

  /* All the same stuff for IE */
  input[type=range]::-ms-thumb {
    -webkit-box-shadow: 0 0 4px 0 rgba(0,0,0,0.3);
    box-shadow: 0 0 4px 0 rgba(0,0,0,0.3);
    border: none;
    height: 15px;
    width: 15px;
    border-radius: 30px;
    background: #ffffff;
    cursor: pointer;
  }

  /* TRACK */

  input[type=range]::-webkit-slider-runnable-track {
    width: 100%;
    height: 5px;
    cursor: pointer;
    // box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
    background: $color2;
    border-radius: 10px;
    // border: 0.2px solid #010101;
  }

  input[type=range]:focus::-webkit-slider-runnable-track {
    background: #367ebd;
  }

  input[type=range]::-moz-range-track {
    width: 100%;
    height: 5px;
    cursor: pointer;
    // box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
    background: $color2;
    border-radius: 10px;
    border: none;
  }

  input[type=range]::-ms-track {
    width: 100%;
    height: 5px;
    cursor: pointer;
    background: transparent;
    border-color: transparent;
    border-width: 16px 0;
    color: transparent;
  }
  input[type=range]::-ms-fill-lower {
    background: $color2;
    border: none;
    border-radius: 10px;
    // box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
  }
  input[type=range]:focus::-ms-fill-lower {
    background: $color2;
  }
  input[type=range]::-ms-fill-upper {
    background: $color2;
    border: none;
    border-radius: 10px;
    // box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
  }
  input[type=range]:focus::-ms-fill-upper {
    background: $color2;
  }
}

</style>
